import Skeleton from '../common/skeleton';
import Header from '../common/Header/Header';

const PasswordResetSkeleton = () => (
  <div className="claims-details container-fluid p-0">
    <Header linkTo={'/admin/admin-dashboard'} header={'Password Reset Setup'} />
    <form className="border-right-after">
      <div className="Payment-details row">
        <div className="pl-0 col">
          <h3>
            <Skeleton count={1} width={180} containerClassName={'form-label'} />
          </h3>
        </div>
        <div className="col">
          <Skeleton
            count={1}
            height={100}
            containerClassName={'MuiOutlinedInput-multiline p-0 d-flex'}
          />
        </div>
      </div>
      <div className="Payment-details row">
        <div className="pl-0 col">
          <h3 className="mb-4">
            <Skeleton count={1} width={180} containerClassName={'form-label'} />
          </h3>
          <p className="mb-2">
            <Skeleton count={1} width={480} height={16} />
          </p>
          <p>
            <Skeleton count={1} width={120} height={16} />
          </p>
          <p className="mb-2">
            <Skeleton count={1} width={400} height={16} />
          </p>
          <p className="mb-2">
            <Skeleton count={1} width={450} height={16} />
          </p>
          <p>
            <Skeleton count={1} width={250} height={16} />
          </p>
        </div>
        <div className="col">
          <table className="m-0 table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>Publish</th>
                <th style={{ textAlign: 'center' }}>Field</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                <tr key={item}>
                  <td>
                    <div id="formGridresetFirstName" className="form-group">
                      <div className="form-check ">
                        <Skeleton
                          count={1}
                          width={20}
                          height={20}
                          containerClassName={'form-label'}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <Skeleton count={1} width={120} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
);

export default PasswordResetSkeleton;
